import { render } from "./CartItem.vue?vue&type=template&id=bf8172ec&scoped=true"
import script from "./CartItem.vue?vue&type=script&lang=ts"
export * from "./CartItem.vue?vue&type=script&lang=ts"

import "./CartItem.vue?vue&type=style&index=0&id=bf8172ec&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bf8172ec"

export default script